import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-[#2d5f3f]">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Torna alla Home</span>
          </Link>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8" style={{ color: '#0a3d2a' }}>
          Cookie Policy
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            Questo sito web utilizza cookie e tecnologie simili per garantire il corretto 
            funzionamento delle procedure e migliorare l'esperienza di uso delle applicazioni 
            online. Il presente documento fornisce informazioni dettagliate sull'uso dei cookie 
            e di tecnologie similari, su come sono utilizzati da <strong>Alt Bollette SRL</strong> 
            e su come gestirli.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Cosa sono i cookie
          </h2>
          <p className="text-gray-600 mb-6">
            I cookie sono piccoli file di testo che i siti visitati inviano al terminale 
            (computer, tablet, smartphone, etc.) dell'utente, dove vengono memorizzati per 
            essere ritrasmessi agli stessi siti alla visita successiva. I cookie possono essere 
            utilizzati per diverse finalità, come l'esecuzione di autenticazioni informatiche, 
            il monitoraggio di sessioni e la memorizzazione di informazioni.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Tipologie di cookie utilizzati
          </h2>

          <h3 className="text-xl font-semibold mt-6 mb-3" style={{ color: '#2d5f3f' }}>
            Cookie tecnici
          </h3>
          <p className="text-gray-600 mb-4">
            Sono i cookie necessari al funzionamento del sito. Senza questi cookie, il sito 
            potrebbe non funzionare correttamente. Questi cookie non raccolgono informazioni 
            per scopi di marketing e non possono essere disattivati.
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li><strong>Cookie di navigazione:</strong> per garantire la normale navigazione e fruizione del sito</li>
            <li><strong>Cookie di funzionalità:</strong> per memorizzare le preferenze dell'utente</li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-3" style={{ color: '#2d5f3f' }}>
            Cookie di terze parti
          </h3>
          <p className="text-gray-600 mb-6">
            Il nostro sito può contenere collegamenti e funzionalità che permettono l'accesso 
            a siti di terze parti (es: Google Maps per la localizzazione, servizi di hosting). 
            Questi siti hanno una propria cookie policy che non è controllata da Alt Bollette.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Cookie utilizzati su questo sito
          </h2>
          
          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="text-left py-2 px-2">Nome</th>
                  <th className="text-left py-2 px-2">Tipo</th>
                  <th className="text-left py-2 px-2">Durata</th>
                  <th className="text-left py-2 px-2">Scopo</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-2 px-2 font-mono text-xs">session_id</td>
                  <td className="py-2 px-2">Tecnico</td>
                  <td className="py-2 px-2">Sessione</td>
                  <td className="py-2 px-2">Mantenere la sessione utente</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-2 px-2 font-mono text-xs">preferences</td>
                  <td className="py-2 px-2">Tecnico</td>
                  <td className="py-2 px-2">1 anno</td>
                  <td className="py-2 px-2">Memorizzare preferenze utente</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Gestione dei cookie
          </h2>
          <p className="text-gray-600 mb-4">
            L'utente può gestire le proprie preferenze relative ai cookie attraverso le 
            impostazioni del proprio browser. Di seguito i link alle guide dei principali browser:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li><a href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline">Safari</a></li>
            <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-[#2d5f3f] hover:underline">Microsoft Edge</a></li>
          </ul>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
            <p className="text-gray-700">
              <strong>Nota:</strong> La disabilitazione dei cookie tecnici può compromettere 
              l'utilizzo delle funzionalità del sito.
            </p>
          </div>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Cookie di analytics
          </h2>
          <p className="text-gray-600 mb-6">
            Attualmente il sito non utilizza cookie di analytics o tracciamento. In caso di 
            implementazione futura, verrà richiesto il consenso esplicito dell'utente.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Modifiche alla Cookie Policy
          </h2>
          <p className="text-gray-600 mb-6">
            Alt Bollette SRL si riserva il diritto di modificare o aggiornare questa Cookie 
            Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con 
            indicazione della data di ultimo aggiornamento.
          </p>

          <h2 className="text-2xl font-bold mt-8 mb-4" style={{ color: '#0a3d2a' }}>
            Contatti
          </h2>
          <p className="text-gray-600 mb-6">
            Per qualsiasi informazione relativa alla presente Cookie Policy può contattare:
          </p>
          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <p className="text-gray-700 font-semibold mb-2">Alt Bollette SRL</p>
            <p className="text-gray-600">Corso Mazzini 76, 48022 Lugo (RA)</p>
            <p className="text-gray-600">Email: amministrazione@altbollette.info</p>
            <p className="text-gray-600">Telefono: +39 350 148 3135</p>
          </div>

          <p className="text-sm text-gray-500 mt-8">
            Ultimo aggiornamento: Dicembre 2024
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
